import React from 'react'
import HeroSection5 from '../Components/HeroSection5/Hero5'
import Card3 from '../Components/Card_car/Card3'
import Footer from '../Components/Footer/Footer'
import ScrollToTop from '../Components/ScrollToTop'
import Slider2 from '../Components/Slider2/Slider2'

const Cars = () => {
  return (
    <>
      <ScrollToTop />
      <HeroSection5 />
      <Slider2 />
      <Card3 />
      <Footer />
    </>
  )
}

export default Cars